import { z } from "zod";

const RequestUploadFileDtoSchema = z.object({
    id: z.string().nullish(),
    fileId: z.string().nullish(),
    fileName: z.string().nullish(),
    fileExtension: z.string().nullish(),
    fileChunk: z.instanceof(Uint8Array),
    size: z.number(),
    taxonomyId: z.number().nullish(),
});

export const UploadIdCardInputSchema = z.object({
    userName: z.string().nullish(),
    requestId: z.string().min(1),
    isUploadFinished: z.boolean().nullish(),
    uploadSessionId: z.string().nullish(),
    fileToUpload: RequestUploadFileDtoSchema,
});

export type UploadIdCardInput = z.infer<typeof UploadIdCardInputSchema>;
